/**
 * A link in a guide is a link, and nothing else.
 *
 * `StyledLink` - the mark the contract and mail editors use - forces
 * `class="text-primary underline"` onto every link, and tiptap's own default
 * adds `target="_blank" rel="noopener noreferrer nofollow"`. Both are right
 * where they came from: that text is rendered outside `.crm-doc`, and a link in
 * a contract really does point out of the app.
 *
 * Neither is right here. The reader already styles `.crm-doc a`, so the class
 * is a second opinion about the same link, and the handbook's links are mostly
 * cross-references between guides - `target="_blank"` turns "see the access
 * guide" into a new browser tab for every step of a procedure. The 158 links in
 * the seeded guides carry a bare `href`, and this keeps it that way.
 *
 * `addOptions` rather than `configure({ HTMLAttributes: {} })`: options are
 * merged, not replaced, so an empty object leaves the defaults exactly where
 * they were. Replacing the option is the only way to have none.
 */
import Link, { type LinkOptions } from "@tiptap/extension-link";

export const KbLink = Link.extend({
  addOptions(): LinkOptions {
    // `parent` is typed optional because an extension need not define options.
    // This one does - it is the mark being extended - so the call is safe, and
    // spreading `undefined` would drop every required field.
    return { ...this.parent!(), openOnClick: false, autolink: false, HTMLAttributes: {} };
  },
});
